import { useEffect } from 'react';

import { StepProps } from '~/types';
import SignupStep from './SignupStep';

const TrialInfoStep = (props: StepProps) => {
	useEffect(() => {
		props.userUpdatePaymentDetails({
			payment_method: 'trial'
		});
	}, []);

	return (
		<SignupStep>
			{({ signupConfig }) => {
				const { trial } = signupConfig.course.subscription;
				return (
					<>
						<h1>About the trial</h1>
						<hr />
						<p>
							{trial.percent_based
								? `You will have limited access to the webtext for ${trial.duration_description_spelled_out}.`
								: `You will have access to the ${trial.content_description}.`}
						</p>
						<p>
							When you’re ready to pay, click the link in the green banner running across the top of
							the page.
						</p>
						<p>Don’t worry! Your work will still be saved if your trial runs out.</p>
					</>
				);
			}}
		</SignupStep>
	);
};

export default TrialInfoStep;
